<template>
  <div class="image-uploader">
    <div class="progress-spinner progress-spinner__big" v-show="spinner">
      <ProgressSpinner />
    </div>

    <div class="image-uploader__controllers list-controllers">
      <input
        style="display: none"
        type="file"
        ref="file"
        @change="loadImage($event)"
        accept="image/*"
      >

      <div class="list-controllers__demo">
        <div class="progress-spinner progress-spinner_demo" v-show="originLoadSpinner">
          <ProgressSpinner />
        </div>
        <img
          v-show="newFilePath"
          class="list-controllers__image"
          alt="default-picture"
          :src="newFilePath"
        >
      </div>

      <ImageUploaderFileList
        :data-source="fotosArr"
        :active-idx="selectedImageIdx"
        :front-image-id="frontImageFileId"
        @select-file="onSelectImage"
        @delete-file="onDeleteFile"
      />

      <div class="list-controllers__buttons">
        <ToolbarIcons
          type-img="plus"
          title="выбрать изображение для загрузки"
          @click="$refs.file.click()"
        />
        <ToolbarIcons
          type-img="upload"
          :pulsed="!originLoadSpinner && newFilePath !== ''"
          :disabled="newFilePath === ''"
          title="отправить оригинал изображения на сервер"
          @click="uploadOriginImg"
        />
      </div>

    </div>

    <div class="image-uploader__cropper cropper">
      <cropper
        ref="cropperRef"
        class="cropper__tools"
        :src="cropperedFilePath"
        :stencil-props="{
          aspectRatio: cropperAspectRatio
        }"
        @change="change"
      />
      <div class="cropper__preview preview">

        <div class="preview__watermark">
          <img
            class="preview__image"
            :src="previewImagePath"
          >
          <WatermarkGridType
            :grid-type="watermarkType"
            :transparency="transparencyPercent"
          />
        </div>

        <label
          class="preview__check"
          for="check"
          v-show="fotosArr.length > 0 && mainPhoto"
        >
          <input
            type="checkbox"
            id="check"
            v-model="frontImageCheked"
            @change="onFrontImage"
          >
          Сделать главным
          <span v-show="!showInputRadio">
            * главное фото не будет отображено в основном теле новости!
          </span>
        </label>

      </div>
    </div>
      <BaseBtnNew
        name="Водяной знак"
        :disabled="fotosArr.length <= 0"
        @click-btn="switchWatermarkModal(true)"
      >
      <waterMarkIcon/>
      </BaseBtnNew>
      <MiniModal
        v-if="watermarkModal"
        title="Тип водяного знака"
        :close-modal="switchWatermarkModal"
        @click-save="addWatermark"
      >
        <div class="image-uploader__watermark watermark">
          <div class="watermark__modes">
            <WatermarkModeIcon
              @click-icon="selectWatermarkType(1)"
              type-icon="diagonal"
              :active="watermarkType == 1"
            />
            <WatermarkModeIcon
              @click-icon="selectWatermarkType(2)"
              type-icon="horizontal"
              :active="watermarkType == 2"
            />
            <WatermarkModeIcon
              @click-icon="selectWatermarkType(3)"
              type-icon="vertical"
              :active="watermarkType == 3"
            />
          </div>
          <div class="watermark__range">
            <label>
              <span>Прозрачность водяного знака: </span>
              <input
                style="width: 55px; height:32px; margin-left: 10px;"
                type="number"
                placeholder="0-100%"
                v-model="transparency"
                @input="clampTransparency"
                @blur="clampTransparency"
              />
              <!-- <span>{{ transparency + '%' }}</span> -->
            </label>

          </div>
        </div>
      </MiniModal>
    <div class="image-uploader__radio">
      <form v-show="fotosArr.length > 0">
        <h3>Формат:</h3>
        <label>
          <input
            type="radio"
            name="cropSize"
            :value="4/3"
            v-model="cropperAspectRatio"
          >
          4:3
        </label>
        <label v-show="showInputRadio">
          <input
            type="radio"
            name="cropSize"
            :value="16/9"
            v-model="cropperAspectRatio"
          >
          16:9
        </label>
        <label v-show="showInputRadio">
          <input
            type="radio"
            name="cropSize"
            :value="9/16"
            v-model="cropperAspectRatio"
          >
          9:16
        </label>
        <label v-show="showInputRadio">
          <input
            type="radio"
            name="cropSize"
            :value="null"
            v-model="cropperAspectRatio"
            checked
          >
            Произвольный
        </label>
      </form>
    </div>
    <p class="image-uploader__info">
      * Размер фотографии не должен превышать 5 мБ
      Загружать фотографию можно только в форматах: .png, .jpg
    </p>
    <div class="image-uploader__buttons">
      <BaseBtnNew
        name="Сохранить"
        :disabled="fotosArr.length <= 0"
        @click-btn="onSaveFotos(fotosArr)"
      >
      <SaveIconNew/>
      </BaseBtnNew>
      <BaseBtnNew
        red
        name="Отменить"
        @click-btn="closeModal()"
      >
      <CancelIcon/>
      </BaseBtnNew>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, computed } from 'vue'
import { useStore } from 'vuex'

import ToolbarIcons from '@/components/icons/ToolbarIcons.vue'
import BaseBtnNew from '@/components/ui/BaseBtnNew.vue'
import MiniModal from '@/components/modals/MiniModal.vue'
import WatermarkModeIcon from '@/components/icons/WatermarkModeIcon.vue'
import ImageUploaderFileList from '@/components/elements/ImageUploaderFileList.vue'
import WatermarkGridType from '@/components/icons/WatermarkGridType.vue'
import waterMarkIcon from '@/components/icons/waterMarkIcon.vue'

import ProgressSpinner from 'primevue/progressspinner'
import CancelIcon from '@/components/icons/CancelIcon.vue'
import SaveIconNew from '@/components/icons/SaveIconNew.vue'

import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import 'vue-advanced-cropper/dist/theme.classic.css'

function getMimeType (file, fallback = null) {
  const byteArray = (new Uint8Array(file)).subarray(0, 4)
  let header = ''
  for (let i = 0; i < byteArray?.length; i++) {
    header += byteArray[i].toString(16)
  }
  switch (header) {
    case '89504e47':
      return 'image/png'
    case '47494638':
      return 'image/gif'
    case 'ffd8ffe0':
    case 'ffd8ffe1':
    case 'ffd8ffe2':
    case 'ffd8ffe3':
    case 'ffd8ffe8':
      return 'image/jpeg'
    default:
      return fallback
  }
}

export default {
  name: 'ImageUploader',
  components: {
    Cropper,
    ToolbarIcons,
    BaseBtnNew,
    MiniModal,
    WatermarkModeIcon,
    SaveIconNew,
    CancelIcon,
    ProgressSpinner,
    ImageUploaderFileList,
    WatermarkGridType,
    waterMarkIcon
  },
  props: {
    forContentBlocks: {
      type: Boolean,
      default: false
    },
    mainPhoto: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    const store = useStore()

    const file = ref(null)

    // ----------- состояния интерфейса (начало)-------
    const envUrlBase = ref(null)

    // const envUrlBase = process.env.VUE_APP_URL_BASE + '/' // url для фоток

    onMounted(() => {
      if (localStorage.activeProject === 'site') {
        envUrlBase.value = process.env.VUE_APP_URL_BASE + '/'
      } else if (localStorage.activeProject === 'education') {
        envUrlBase.value = process.env.VUE_APP_URL_EDUCATION + '/'
      }
    })

    const spinner = ref(false) // спиннер при отправке коллекции фото
    const originLoadSpinner = ref(false) // спинер при загрузке оригинала

    const closeModal = () => {
      emit('closeModal', 'all', false)
    }
    // ----------- состояния интерфейса (конец)-------

    // ----------- состояния для логики (начало) ------
    const cropperRef = ref(null) // ref ссылка на обрезчик
    const originFile = ref() // файл выбранный в инпуте
    const newFilePath = ref('') // картинка возле кнопки +
    const cropperAspectRatio = ref() // соотношение сторон формы для обрезки
    const image = ref({ // картинка в обрезчике
      src: null,
      type: null
    })
    const previewImagePath = ref('') // изображение превьюшка которая показывает как выглядит фото после редактироваения с обрезкой и водяным знаком
    const parentFileData = computed(() => store.getters.getParentFileData) // path и id оригинала после его отправки на сервер
    const fotosArr = ref([]) // массив фоток
    const selectedOriginImage = ref(null) // выбранный орингинал из загруженных
    const selectedImageIdx = ref(0) // id выбранного орингинала из загруженных

    const cropperedFilePath = computed(() => {
      // то фото что сейчас обрезается
      if (fotosArr.value.length > 0 && selectedOriginImage.value) {
        // если массив заруженных картинок не пустой и какое-то фото выбрано то возвращает его путь
        return envUrlBase.value + fotosArr.value[selectedOriginImage.value.idx]?.SourceFilePath
      } else {
        // если нет то дефолтная картинка
        return ''
        // return require('@/assets/images/png/other/no-image.png')
      }
    })

    const frontImageFileId = computed(() => { // id картинки которая является заставкой
      return store.getters.getFormData?.FrontImageFileId
    })
    // ----------- состояния для логики (конец) ------

    // --------- работа с оригиналами и их списком (начало) --------
    const loadImage = (event) => { // загр с компа
      // Ссылка на элемент ввода DOM
      const { files } = event.target

      originFile.value = files

      // Убедитесь, что у вас есть файл, прежде чем пытаться его прочитать
      if (files && files[0]) {
        // 1. Отменить URL-адрес объекта, чтобы сборщик мусора мог уничтожить ранее загруженный файл.
        if (image.value.src) {
          URL.revokeObjectURL(image.value.src)
        }
        // 2. Создайте ссылку на файл, чтобы оптимизировать производительность:
        const blob = URL.createObjectURL(files[0])
        newFilePath.value = blob // картинка возле кнопки плюс
        // 3. Описанные ниже шаги предназначены для определения MIME-типа файла, чтобы использовать его во время

        // Создайте новый FileReader для чтения двоичных данных этого изображения.
        const reader = new FileReader()
        // Определите функцию обратного вызова для запуска, когда FileReader закончит свою работу
        reader.onload = (e) => {
          image.value = {
            // Установите источник изображения (это будет выглядеть как blob: http://example.com/2c5270a5-18b5-406e-a4fb-07427f5e7b94)
            src: blob,
            // Определите тип изображения, чтобы сохранить его во время извлечения изображения из холста:
            type: getMimeType(e.target.result, files[0].type)
          }
          newFilePath.value = blob // картинка возле кнопки плюс
        }
        // Запустите задание чтения - прочитайте файл как URL-адрес данных (формат base64)
        reader.readAsArrayBuffer(files[0])
      }
    }

    const uploadOriginImg = async () => { // отправить оригинал на бек
      originLoadSpinner.value = true

      const form = new FormData()
      form.append('file', originFile.value[0])

      // store.commit('SetUploaderFormFile', form) // добавляю файл в стор

      if (localStorage.activeProject === 'site') {
        // отправляет оригинал на сервер
        await store.dispatch('setUploadImage', form)
          .finally(() => {
            originLoadSpinner.value = false
          })
      } else if (localStorage.activeProject === 'education') {
        await store.dispatch('setUploadImageEducation', form)
          .finally(() => {
            originLoadSpinner.value = false
          })
      }

      // добавляет в массив картинок путь на оригинал что пришел в ответе с сервера
      fotosArr.value.push({
        SourceFilePath: parentFileData.value.FilePath,
        FileId: parentFileData.value.FileId,
        Transparency: null,
        WatermarkType: 0,
        Width: 0,
        Height: 0,
        Left: 0,
        Top: 0,
        idx: 0
      })

      const lastIdx = fotosArr.value.length - 1

      onSelectImage(fotosArr.value[lastIdx], lastIdx)

      // возвращает дефолтную картинку в картинку возле +
      newFilePath.value = ''

      if (file.value) {
        file.value.value = '' // Это важно!
      }
    }

    const onSelectImage = (obj, idx) => { // выбирает среди оригиналов
      selectedOriginImage.value = obj
      selectedOriginImage.value.idx = idx
      selectedImageIdx.value = idx
      // динамически добавляет id в соответствии с порядковым индексом в массиве
      transparency.value = obj.Transparency ?? ''
      watermarkType.value = obj.WatermarkType
      // показывает ватермарку уже примененную ранее

      if (obj.FileId !== frontImageFileId.value) {
        // если выбранное фото не является заставкой то чекбокс false
        frontImageCheked.value = false
        cropperAspectRatio.value = null
      } else {
        // если выбранное фото является заставкой то чекбокс true
        frontImageCheked.value = true
        if (props.forContentBlocks) cropperAspectRatio.value = 4 / 3
      }

      resize() // при каждом выборе фото трафарет меняет размер
    }

    const onDeleteFile = (idx) => {
      fotosArr.value = fotosArr.value.filter((item, i) => i !== idx)

      const lastIdx = fotosArr.value.length - 1
      if (lastIdx >= 0) {
        onSelectImage(fotosArr.value[lastIdx], lastIdx)
      } else {
        previewImagePath.value = ''
      }
    }

    const clearData = () => { // вызывается через ref при вызове модалки из конструктора когда создается новый контент блок
      fotosArr.value = []
      transparency.value = ''
      watermarkType.value = 0
      previewImagePath.value = ''
    }
    // --------- работа с оригиналами и их списком (конец) --------

    // ------------cropper - обрезчик фото (начало) --------------
    const change = ({ coordinates, canvas }) => {
      // координаты обрезки присваиваются объекту фотографии

      fotosArr.value.forEach((item, i) => {
        if (selectedOriginImage.value !== null && i === selectedOriginImage.value.idx) {
          item.Width = coordinates.width
          item.Height = coordinates.height
          item.Left = coordinates.left
          item.Top = coordinates.top
        }
      })

      previewImagePath.value = `${canvas?.toDataURL()}`// тут предварительный просмотр
    }

    const resize = () => {
      // если изображение обрезается впервые то трафарет обрезки растягивается на всё фото, иначе трафарет обрезки располагается в соответсвии с координатами прошлой обрезки
      if (fotosArr.value[selectedImageIdx.value].Width === 0) {
        cropperRef.value.setCoordinates(({ coordinates, imageSize }) => ({
          width: imageSize.width,
          height: imageSize.height
        }))
      } else {
        cropperRef.value.setCoordinates(
          {
            width: fotosArr.value[selectedImageIdx.value].Width,
            height: fotosArr.value[selectedImageIdx.value].Height,
            left: fotosArr.value[selectedImageIdx.value].Left,
            top: fotosArr.value[selectedImageIdx.value].Top
          }
        )
      }
    }
    // ------------cropper - обрезчик фото (конец) --------------

    // ----------- добавление ватермарки (начало) ----------------
    const watermarkModal = ref(false) // показать минимодал с вод. знаком
    const transparency = ref('')
    const transparencyPercent = computed(() => {
      return `${transparency.value === null || transparency.value === '' ? 0 : transparency.value}%`
    })
    const watermarkType = ref(1) // тип вод. знака

    const clampTransparency = () => {
      if (transparency.value === null || transparency.value === '') {
        return
      }

      const value = Number(transparency.value)

      if (Number.isNaN(value)) {
        transparency.value = ''
        return
      }

      transparency.value = Math.min(100, Math.max(0, value))
    }

    const switchWatermarkModal = (val) => {
      watermarkModal.value = val
    }
    const selectWatermarkType = (type) => {
      watermarkType.value = type
    }

    const addWatermark = () => {
      fotosArr.value.forEach((item, i) => {
        if (selectedOriginImage.value !== null && i === selectedOriginImage.value.idx) {
          item.WatermarkType = watermarkType.value
          item.Transparency = transparency.value === null || transparency.value === '' ? 0 : Number(transparency.value)
        }
      })

      watermarkModal.value = false
    }
    // ----------- добавление ватермарки (конец) ----------------

    // ------- делает фото главным (заставкой) (начало) ---------
    const frontImageCheked = ref(false) // сделать ли заставкой

    const showInputRadio = computed(() => {
      // показывать остальные варианты трафарета
      if (frontImageCheked.value && props.forContentBlocks) return false
      return true
    })

    const onFrontImage = () => { // клик на чекбокс ^
      if (frontImageCheked.value) {
        store.commit('SetFrontImageFileId', selectedOriginImage.value.FileId)
      }

      // при высталвении флага у одной фотки убираем его у других
      fotosArr.value.forEach((item) => {
        if (item.FileId === selectedOriginImage.value.FileId) {
          item.IsFrontImage = frontImageCheked.value
        } else {
          item.IsFrontImage = false
        }
      })

      if (props.forContentBlocks && frontImageCheked.value) {
        cropperAspectRatio.value = 4 / 3
      }
    }
    // ------- делает фото главным (заставкой) (конец) ---------

    // -------- отправка на серв массива картинок (начало) ------
    const onSaveFotos = async (arr) => {
      // включает главный спиннер
      spinner.value = true

      const newArr = arr.map((item) => {
        return {
          SourceFilePath: item.SourceFilePath,
          FileId: item.FileId,
          Transparency: item.Transparency ?? 0,
          IsFrontImage: item.IsFrontImage,
          WatermarkType: item.WatermarkType,
          Width: item.Width.toFixed(),
          Height: item.Height.toFixed(),
          Left: item.Left.toFixed(),
          Top: item.Top.toFixed()
        }
      })

      if (localStorage.activeProject === 'site') {
        // отправка на сервер после чего отрубает спиннер
        await store.dispatch('setSaveEditImage', newArr)
          .finally(() => {
            spinner.value = false
          })
      } else if (localStorage.activeProject === 'education') {
        await store.dispatch('setSaveEditImageEducation', newArr)
          .finally(() => {
            spinner.value = false
          })
      }

      // закрывает модалку и очищает форму
      closeModal()
      clearData()
    }
    // -------- отправка на серв массива картинок (конец) -------

    return {
      change,
      file,
      envUrlBase,
      showInputRadio,
      cropperAspectRatio,
      image,
      loadImage,
      newFilePath,
      uploadOriginImg,
      frontImageCheked,
      onFrontImage,
      watermarkModal,
      switchWatermarkModal,
      selectWatermarkType,
      watermarkType,
      clampTransparency,
      transparencyPercent,
      addWatermark,
      transparency,
      spinner,
      originLoadSpinner,
      fotosArr,
      onSelectImage,
      selectedOriginImage,
      cropperedFilePath,
      previewImagePath,
      cropperRef,
      resize,
      onSaveFotos,
      onDeleteFile,
      selectedImageIdx,
      frontImageFileId,
      closeModal,
      clearData
    }
  }
}
</script>

<style lang="scss" scoped>
.image-uploader {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  // width: 78.104vw;
  color: #000000;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.02em;

  &__controllers, .list-controllers {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;

    &__demo {
      position: relative;
      width: 153px;
      height: 86px;
      border-radius: 6px;
      background-image: url('@/assets/images/png/other/no-image.png');
      background-repeat: no-repeat;
      background-size: contain;
    }

    &__image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &__buttons {
      display: flex;
      gap: 10px;
    }
  }

  &__cropper, .cropper {
    display: flex;
    margin-bottom: 12px;
    gap: 30px;

    &__preview, .preview {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 10px;

      &__watermark {
        position: relative;
      }

      &__image {
        max-width: 343px;
        max-height: 193px;
        object-fit: contain;
        border-radius: 6px;
      }

      &__check {
        text-align: start;
        cursor: pointer;

        input {
          cursor: pointer;
        }

        span {
          display: block;
          color: darkred;
          font-size: 14px;
        }

      }
    }

    &__tools {
      width: 584px;
      height: 305px;
      // background-image: url('@/assets/images/png/other/no-image-big.png');
      // background-repeat: no-repeat;
      // background-size: contain;

      :deep(.vue-advanced-cropper__background) {
        background: #FFFFFF;
        // background: #e9e9e9;
      }
      :deep(.vue-advanced-cropper__foreground) {
        opacity: 0.2;
      }

      :deep(.vue-simple-handler) {
        background: #00ABEC;
        height: 10px;
        width: 10px;
      }
    }
  }

  &__watermark, .watermark {
    // position: relative;

    &__modes {
      display: flex;
      gap: 30px;
      margin-bottom: 25px;
    }

    &__range {
      margin-bottom: 40px;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: -0.02em;
    }
  }

  &__radio {
    height: 150px;
    padding: 20px 0;

    label, input {
      cursor: pointer;
    }

    form {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &__info {
    margin-bottom: 39px;
      font-weight: 700;
      font-size: 16px;
  }

  &__buttons {
    position: absolute;
    right: -24px;
    left: -24px;
    bottom: -24px;
    padding: 24px;
    border-top: 2px solid #D6D6D6;
    background-color: #F5F5F5;
    display: flex;
    justify-content: flex-end;
    gap: 30px;
    width: calc(100% + 48px);
    :deep(.base-button) {
      width: 200px;
    }
  }
}

.progress-spinner {
  position: absolute;
  inset: 0;
  @include flex-center;
  z-index: 3;
  background-color: rgb(0, 0, 0, 0.3);

  &__big {
    // left: -31px;
    // top: -77px;
    // right: -34px;
    // bottom: -51px;
    position: fixed;
  }

  &_demo {
    width: 100%;
    height: 100%;
  }
}
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
  appearance: textfield;
}

</style>
